import {Controller} from "@hotwired/stimulus"
import {Turbo} from "@hotwired/turbo-rails";

export default class extends Controller {
  static targets = ["input", "suggestions"] // No change here, Stimulus maps data-*-target to this


  connect() {
    this.init_event_listeners();
    this.selectedIndex = -1
  }

  initialize() {
  }

  open() {
    console.log("Search dialog opened!");
    this.element.showModal()
  }

  close() {
    this.element.close()
  }

  init_event_listeners() {
    this.element.addEventListener('hotkey-fire', event => {
      // ensure the default `focus()`/`click()` is prevented:
      event.preventDefault();
      this.open();
    });

    this.element.addEventListener('mousedown', event => {
      if (event.target === event.currentTarget) {
        event.currentTarget.close()
      }
    });

    this.inputTarget.addEventListener("keydown", this.onKeydown.bind(this))
  }

  disconnect() {
    this.element.removeEventListener('hotkey-fire', event => {
      event.preventDefault();
      this.open();
    });

    this.element.removeEventListener('mousedown', event => {
      if (event.target === event.currentTarget) {
        event.currentTarget.close()
      }
    });

    this.inputTarget.removeEventListener("keydown", this.onKeydown.bind(this))

    this.close();
  }

  onKeydown(event) {
    // if (this.suggestionsTarget.classList.contains("hidden")) return

    if (this.items.length === 0) return

    if (event.key === "ArrowDown") {
      event.preventDefault()
      this.moveSelection('down')
    } else if (event.key === "ArrowUp") {
      event.preventDefault()
      this.moveSelection('up')
    } else if (event.key === "Enter" || event.key === "Tab") {
      // click first item if enter clicked
      if (this.selectedIndex == -1 && this.items.length > 0) {
        const link = this.items[0].querySelector('a')//.click()
        Turbo.visit(link.href, { action: "advance" });
      } else {
        this.items[this.selectedIndex].querySelector('a').click()
      }
    } else if (event.key === "Escape") {
      this.inputTarget.focus()
    }
  }

  moveSelection(direction) {
    if (direction === "down") {
      this.selectedIndex = (this.selectedIndex + 1) % this.items.length
    } else if (direction === "up") {
      this.selectedIndex = (this.selectedIndex - 1 + this.items.length) % this.items.length
    }
    this.highlightSelectedItem()
  }

  highlightSelectedItem() {
    this.items.forEach((item, index) => {
      item.classList.toggle("bg-gray-200", index === this.selectedIndex)
    })
    // Optional: Scroll into view if suggestions are long
    if (this.selectedIndex !== -1) {
      this.items[this.selectedIndex].scrollIntoView({block: "nearest"})
    }
  }

  get items() {
    return Array.from(this.suggestionsTarget.querySelectorAll('.list-group-item'));
  }
};
